/**
 * List Schema of ResponsavelUsuario
 * @author Simpli CLI generator
 */
import {
  Schema,
  FieldSet,
  FieldComponent,
  Component,
  Helper,
} from 'simpli-web-sdk'
import {ResponsavelUsuario} from '@/model/resource/ResponsavelUsuario'

/* TODO: review generated schema */
export class ListResponsavelUsuarioSchema extends Schema {
  readonly name = 'ListResponsavelUsuario'

  readonly fieldSet: FieldSet<ResponsavelUsuario> = {
    idResponsavelUsuarioPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    email: (): FieldComponent => ({
      is: Component.Render,
    }),
    tipoResponsavelUsuario: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.tipoResponsavelUsuario?.$tag,
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
